module.exports = __webpack_public_path__ + "media/images/favicons/32-a6f1b278bdcac63b01b578c5aa46320c.png";